export default __webpack_public_path__ + "static/media/logo.a1f3dee1.svg";